var map = {
	"./excel.png": "c1c6",
	"./pdf.png": "643f",
	"./pic.png": "bf10",
	"./ppt.png": "0402",
	"./txt.png": "1504",
	"./ty_xtb_gou.png": "033f",
	"./unknow.png": "7057",
	"./upload.png": "4ade",
	"./word.png": "3951",
	"./wps.png": "5073"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26e9";